import styled from 'styled-components';

export const AppFrame = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  grid-template-rows: auto auto minmax(0, 1fr);
  background: ${p => p.theme.bg};

  @media (max-width: 920px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto minmax(0, 1fr);
  }
`;

export const SidebarColumn = styled.aside`
  position: sticky;
  top: 0;
  grid-column: 1;
  grid-row: 1 / -1;
  height: 100vh;
  overflow-y: auto;
  background: ${p => p.theme.surface};
  color: ${p => p.theme.text};
  border-right: 1px solid ${p => p.theme.border};
  padding: 22px 14px 16px;

  @media (max-width: 920px) {
    position: sticky;
    top: 0;
    z-index: 60;
    grid-column: 1;
    grid-row: 1;
    height: auto;
    max-height: 70vh;
    border-right: 0;
    border-bottom: 1px solid ${p => p.theme.border};
    padding: 14px 16px;
  }
`;

export const MainContent = styled.main`
  grid-column: 2;
  grid-row: 3;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: min(1560px, 100%);
  margin: 0 auto;
  padding: 28px 28px 56px;

  @media (max-width: 1100px) {
    padding: 32px;
  }

  @media (max-width: 920px) {
    grid-column: 1;
    grid-row: 4;
    padding: 24px 16px;
  }
`;
